// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"Header__pc_only___RMDlR","sp_only":"Header__sp_only___4X_s0","header":"Header__header___1zHqU","active":"Header__active___3vJxI"};